import { getMarketFromPath } from "Market/Utilities/getMarketFromPath";

export const useMarketNavigate = () => {
	return (path: string, market?: string) => {
		const marketPath = market ?? getMarketFromPath();
		window.location.href = `${marketPath !== "" ? `/${marketPath}` : ""}${path}`;
	};
};
